import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

// Connects to data-controller="attendance-progress" on the day-of attendance
// panel. Polls the check-in stats endpoint every 30s and updates the donut ring,
// percentage, and the checked-in / remaining / total counts live as the
// organizer checks people in. Stops polling once the window closes (open:false).
export default class extends Controller {
  static targets = ["ring", "percent", "checkedIn", "remaining", "total", "caption"]
  static values = {
    url: String,
    circumference: Number,
    checkedInLabel: String, // "{checked_in} of {total} attendees checked in"
  }

  connect() {
    this.timer = setInterval(() => this.refresh(), 30000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  async refresh() {
    try {
      const response = await get(this.urlValue, { responseKind: "json" })
      if (!response.ok) return
      const data = await response.json
      if (!data.open) {
        // Window closed — stop polling. (A reload will show recommendations.)
        if (this.timer) clearInterval(this.timer)
        return
      }
      this.render(data)
    } catch (e) {
      /* transient network error — keep the last values, try again next tick */
    }
  }

  render(data) {
    if (this.hasPercentTarget) this.percentTarget.textContent = `${data.percent}%`
    if (this.hasCheckedInTarget) this.checkedInTarget.textContent = data.checked_in
    if (this.hasRemainingTarget) this.remainingTarget.textContent = data.remaining
    if (this.hasTotalTarget) this.totalTarget.textContent = data.total

    if (this.hasRingTarget && this.hasCircumferenceValue) {
      const offset = this.circumferenceValue * (1 - data.percent / 100)
      this.ringTarget.style.strokeDashoffset = offset.toFixed(2)
    }

    if (this.hasCaptionTarget && this.hasCheckedInLabelValue) {
      this.captionTarget.textContent = this.checkedInLabelValue
        .replace("{checked_in}", data.checked_in)
        .replace("{total}", data.total)
    }
  }
}
